module.exports = __webpack_public_path__ + "img/06.21317e82.jpg";